module.exports = __webpack_public_path__ + "static/img/6.0ac11e8d.png";